import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Checkbox from '@material-ui/core/Checkbox';
import { textLink } from '../../../styled/mixins';
import GlobalTheme from '../../../styled/GlobalTheme';

const Container = styled.div`
  margin: 13px 0 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${GlobalTheme.breakpoints.down('sm')}{

    justify-content: center;
    margin-bottom: 13px;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;

  width:50%;
  ${GlobalTheme.breakpoints.down('sm')}{
    width:85%;
  }
`;

const CustomCheckbox = styled(Checkbox)`
  &&{
    .MuiSvgIcon-root {
      fill: ${({ isApp, theme }) => isApp && theme.colors.secondary}
    }
    ${({ isApp }) => isApp && `
      padding: 0;
    `}
  }
`;

const TextLink = styled.a`
  ${textLink}
  ${GlobalTheme.breakpoints.down('sm')}{
    font-size: 14px;
    text-align: right;
    width: 100%;
  }
  ${({ isApp, theme }) => isApp && `
    color: ${theme.colors.white}
  `}
`;

const Text = styled.p`
  color: ${({ theme }) => (theme.colors.chartGray)};
  margin: 0 5px 0 0;
  ${GlobalTheme.breakpoints.down('xs')}{
    font-size: 14px !important;
  }
  ${GlobalTheme.breakpoints.down('sm')}{
    font-size: 16px
  }
  ${({ isApp, theme }) => isApp && `
    color: ${theme.colors.white}
  `}
`;

const LoginOptionsBox = ({ setOpen, isApp }) => {
  const [checked, setChecked] = useState(true);
  const handleCheckBoxChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  return (
    <Container>
      <CheckboxContainer>
        <CustomCheckbox
          color={isApp ? 'secondary' : 'primary'}
          checked={checked}
          onChange={handleCheckBoxChange}
          inputProps={{ 'aria-label': 'primary checkbox' }}
          isApp={isApp}
        />
        <Text isApp={isApp}>
          <FormattedMessage
            id="login.rememberMe.text"
            defaultMessage="Remember me"
          />
        </Text>
      </CheckboxContainer>
      <TextLink href="#" onClick={handleClickOpen} isApp={isApp}>
        <FormattedMessage
          id="login.forgotPassword"
          defaultMessage="Forgot Password?"
        />
      </TextLink>
    </Container>
  );
};

LoginOptionsBox.propTypes = {
  setOpen: PropTypes.func.isRequired,
  isApp: PropTypes.bool,
};

LoginOptionsBox.defaultProps = {
  isApp: false,
};

export default LoginOptionsBox;
